import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "@/pages/LegalLayout";

export default function Privacy() {
  const { t } = useTranslation();
  return (
    <LegalLayout titleKey="privacy.title" updatedKey="privacy.updated">
      <p>{t("privacy.intro")}</p>
      {[1,2,3,4,5,6,7,8,9].map((i) => (
        <React.Fragment key={i}>
          <h2>{t(`privacy.s${i}_t`)}</h2>
          <p>{t(`privacy.s${i}_p`)}</p>
        </React.Fragment>
      ))}
    </LegalLayout>
  );
}
